<iframe
  [src]="src"
  title="Diwali Unlimited Dhamaka"
  class="fsmo2-frame"
  loading="eager"
  allow="autoplay; clipboard-write; accelerometer; gyroscope"
  referrerpolicy="no-referrer"
  frameborder="0"></iframe>
